'use client'

import { Log } from "../../lib/definitions";
import LogTableRows from "./logTableRows";

import styles from "./page.module.css";

type Props = {
  currentLog?: Log
  logs: Log[]
  hasRemainingLogs: boolean
  fetchMoreLogs: () => Promise<void>
}
const LogTable = ({ currentLog, logs, hasRemainingLogs, fetchMoreLogs }: Props) => {
  return (
    <div className={styles.table}>
      <div className={styles.tableHeader}>
        <div className={styles.tableHeaderProblemId}>
          <p>ID</p>
        </div>
        <div className={styles.tableHeaderProblemName}>
          <p>Name</p>
        </div>
        <div className={styles.tableHeaderRating}>
          <p>Rating</p>
        </div>
        <div className={styles.tableHeaderDefense}>
          <p>Defense</p>
        </div>
        <div className={styles.tableHeaderStatus}>
          <p>Status</p>
        </div>
        <div className={styles.tableHeaderElapsedTime}>
          <p>Elapsed Time</p>
        </div>
      </div>
      <LogTableRows currentLog={currentLog} logs={logs} />
      {hasRemainingLogs &&
        <button className={styles.fetchMoreLogs} onClick={fetchMoreLogs}>Fetch More Logs</button>
      }
    </div>
  )
}

export default LogTable